import React from 'react';
import {
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import { Field } from 'formik';
import CustomInputWithIcon from '../../common/ui/CustomInputWithIcon';

const ProjectDBConfig = () => {
  return (
    <AccordionItem uuid="project-db-config">
      <AccordionItemHeading>
        <AccordionItemButton>
          <i className={`wb`}></i>
          <strong>Project Database Configuration (Mongo DB)</strong>
        </AccordionItemButton>
      </AccordionItemHeading>
      <AccordionItemPanel>
        <div className="row">
          <div className="col-md-6">
            <CustomInputWithIcon icon="text">
              <Field
                name="project.host"
                className="form-control form-control-sm"
                placeholder="Database Host/IP"
                title="Enter Database Host/IP"
              />
            </CustomInputWithIcon>
          </div>
          <div className="col-md-6">
            <CustomInputWithIcon icon="text">
              <Field
                name="project.port"
                className="form-control form-control-sm"
                placeholder="Database Port"
                title="Enter Database Port"
              />
            </CustomInputWithIcon>
          </div>
          <div className="col-md-6">
            <CustomInputWithIcon icon="text">
              <Field
                name="project.username"
                className="form-control form-control-sm"
                placeholder="Database Username"
                title="Enter Database Username"
              />
            </CustomInputWithIcon>
          </div>
          <div className="col-md-6">
            <CustomInputWithIcon icon="text">
              <Field
                type="password"
                name="project.password"
                className="form-control form-control-sm"
                placeholder="Database Password"
                title="Enter Database Password"
              />
            </CustomInputWithIcon>
          </div>
        </div>
      </AccordionItemPanel>
    </AccordionItem>
  );
};

export default ProjectDBConfig;
